import { hasDivineFavor } from '../../../../shared/rules/effects/buffModifiers.mjs';

export const DIVINE_FAVOR_FEATURE_ID = 'paladin:divine-favor';
const LABEL = 'Divine Favor';
const ineligible = (reasonCode) => ({ status: 'ineligible', featureId: DIVINE_FAVOR_FEATURE_ID, featureLabel: LABEL, reasonCode });

/**
 * 2024 Divine Favor: for 1 minute, the caster's weapon attacks deal an extra 1d4 Radiant damage on a hit. Not optional
 * and not once per turn, so it applies automatically without a usage claim (like Hunter's Mark).
 */
export const evaluateDivineFavor = ({ context, queries = {} }) => {
  if (!context?.attack?.isWeaponAttack) return ineligible('not-weapon-attack');
  if (!hasDivineFavor({ activeEffects: queries.activeEffects }, context.attacker?.combatantId)) return ineligible('no-divine-favor');
  return {
    status: 'automatic', featureId: DIVINE_FAVOR_FEATURE_ID, featureLabel: LABEL, reasonCode: 'divine-favor-active',
    components: [{ id: DIVINE_FAVOR_FEATURE_ID, label: LABEL, source: { type: 'spell', featureId: DIVINE_FAVOR_FEATURE_ID },
      dice: { count: 1, sides: 4 }, flat: 0, damageType: { mode: 'explicit', value: 'radiant' }, critical: { dice: 'double' } }],
    claims: [],
  };
};
